import { firebase } from '../config/configureFirebase';
import { ref, query, orderByChild, limitToLast, startAt, endAt, onValue, get, push, update } from 'firebase/database';

const APP_LOGS = 'app_logs';

export const APP_LOG_LIMITS = { message: 1000, stack: 6000, componentStack: 3000 };

const normalizeForFingerprint = (text) => String(text || '')
  .replace(/https?:\/\/\S+/g, '<url>')
  .replace(/\b[0-9a-f]{8,}\b/gi, '<id>')
  .replace(/-[A-Za-z0-9_-]{19}\b/g, '<id>')
  .replace(/\d+/g, '#')
  .trim()
  .slice(0, 200);

// Los cierres nativos llevan un mensaje fijo: la primera línea de la traza distingue un fallo de otro
const STACK_FINGERPRINT_KINDS = ['native_crash', 'anr'];

export const appLogFingerprint = (log) => {
  const message = normalizeForFingerprint(log?.message);
  const stackHead = STACK_FINGERPRINT_KINDS.includes(log?.kind) && log?.stack
    ? `|${normalizeForFingerprint(String(log.stack).split('\n').find((line) => line.trim()))}`
    : '';
  return `${log?.kind || 'error'}|${message}${stackHead}`;
};

export const subscribeAppLogs = (onData, onError, limit = 1000) => {
  const { database } = firebase;
  if (!database) {
    if (onError) onError(new Error('Firebase no está listo'));
    return () => {};
  }
  const q = query(ref(database, APP_LOGS), orderByChild('ts'), limitToLast(limit));
  return onValue(
    q,
    (snapshot) => {
      const val = snapshot.val() || {};
      onData(
        Object.keys(val)
          .map((id) => ({ id, ...val[id] }))
          .sort((a, b) => (Number(b.ts) || 0) - (Number(a.ts) || 0))
      );
    },
    (error) => {
      if (onError) onError(error);
    }
  );
};

export const pushAppLog = (entry) => push(ref(firebase.database, APP_LOGS), entry);

export const deleteAppLogs = (ids) => {
  const changes = {};
  (ids || []).forEach((id) => {
    if (id) changes[id] = null;
  });
  if (!Object.keys(changes).length) return Promise.resolve(0);
  return update(ref(firebase.database, APP_LOGS), changes).then(() => Object.keys(changes).length);
};

export const deleteAppLogsOlderThan = async (cutoffTs) => {
  const q = query(ref(firebase.database, APP_LOGS), orderByChild('ts'), startAt(0), endAt(cutoffTs));
  const snapshot = await get(q);
  return deleteAppLogs(Object.keys(snapshot.val() || {}));
};
